import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon } from 'lucide-react';

export const NotFound = () => {
  return (
    <div className="App min-h-screen flex items-center justify-center">
      <div className="text-center px-4">
        <div className="text-[#D90429] font-black text-9xl mb-4">404</div>
        <h1 className="text-4xl font-black text-white mb-4">Halaman Tidak Ditemukan</h1>
        <p className="text-gray-400 text-lg mb-8">Maaf, halaman yang Anda cari tidak dapat ditemukan.</p>
        <Link to="/" className="btn-primary inline-flex items-center gap-2">
          <HomeIcon size={20} />
          Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
};